module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-toolbar', {
    staticClass: "pa-0 ma-0 nopadd",
    attrs: {
      "dense": "",
      "flat": "",
      "dark": _vm.dark
    }
  }, [(_vm.colleagueIds && _vm.colleagueIds.length > 1) ? [(_vm.$vuetify.breakpoint.xs) ? _c('v-list', {
    staticClass: "pt-0 mb-0 pl-2",
    attrs: {
      "dark": ""
    }
  }, [_c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.mobileSelectCalendar = true
      }
    }
  }, [_c('v-list-tile-avatar', {
    staticClass: "white--text",
    attrs: {
      "color": "teal"
    }
  }, [(_vm.getProfilePicture(_vm.selected)) ? _c('v-img', {
    attrs: {
      "src": _vm.getProfilePicture(_vm.selected)
    }
  }) : _c('span', [_vm._v(_vm._s(_vm.initials(_vm.selected)))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
    domProps: {
      "textContent": _vm._s(_vm.selectedFullName)
    }
  })], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("expand_more")])], 1)], 1)], 1), _vm._v(" "), _c('v-bottom-sheet', {
    attrs: {
      "persistent": false,
      "inset": ""
    },
    model: {
      value: (_vm.mobileSelectCalendar),
      callback: function($$v) {
        _vm.mobileSelectCalendar = $$v
      },
      expression: "mobileSelectCalendar"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "overline grey lighten-4 py-2"
  }, [_vm._v("\n            Pick a calendar\n            "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.mobileSelectCalendar = false
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', _vm._l((_vm.colleagues), function(colleague) {
    return _c('v-list-tile', {
      key: colleague.id,
      on: {
        "click": function($event) {
          _vm.setSelected(colleague);
          _vm.mobileSelectCalendar = false
        }
      }
    }, [_c('v-list-tile-avatar', {
      staticClass: "white--text",
      attrs: {
        "color": "teal"
      }
    }, [(_vm.getProfilePicture(colleague)) ? _c('v-img', {
      attrs: {
        "src": _vm.getProfilePicture(colleague)
      }
    }) : _c('span', [_vm._v(_vm._s(_vm.initials(colleague)))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "textContent": _vm._s(colleague.full_name)
      }
    })], 1)], 1)
  }), 1)], 1)], 1)], 1) : _c('v-tabs', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('v-tab', {
    on: {
      "click": function($event) {
        return _vm.setSelected(_vm.me)
      }
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-avatar', _vm._g(_vm._b({
          staticClass: "mr-2",
          attrs: {
            "size": "24"
          }
        }, 'v-avatar', attrs, false), on), [(_vm.profilePicture) ? _c('v-img', {
          attrs: {
            "src": _vm.profilePicture
          }
        }) : _c('span', [_vm._v(_vm._s(_vm.initials(_vm.me)))])], 1)]
      }
    }], null, false, 1246988026)
  }, [_vm._v(" "), _c('strong', [_vm._v("it's you!")]), _vm._v(" "), _vm._l((_vm.myMemberships), function(mem) {
    return _c('div', [_vm._v("\n            " + _vm._s(mem.role) + " @ " + _vm._s(mem.title) + "\n          ")])
  })], 2), _vm._v(" "), _c('v-badge', {
    staticClass: "ctabs",
    attrs: {
      "bordered": "",
      "overlap": "",
      "small": "",
      "right": ""
    },
    scopedSlots: _vm._u([{
      key: "badge",
      fn: function() {
        return [_vm._v("+")]
      },
      proxy: true
    }], null, false, 2848459955)
  }, [_vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": "",
      "outline": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.newAppointment(_vm.me)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("event")])], 1)], 1)], 1), _vm._v(" "), _vm._l((_vm.colleagues), function(colleague) {
    return [_c('v-divider', {
      key: ("div-" + (colleague.id)),
      attrs: {
        "vertical": ""
      }
    }), _vm._v(" "), (colleague.id !== _vm.me.id) ? _c('v-tab', {
      key: colleague.id,
      attrs: {
        "outlined": ""
      },
      on: {
        "click": function($event) {
          return _vm.setSelected(colleague)
        }
      }
    }, [_c('v-tooltip', {
      attrs: {
        "bottom": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;
          var attrs = ref.attrs;

          return [_c('v-avatar', _vm._g(_vm._b({
            staticClass: "mr-2 white--text",
            attrs: {
              "size": "24",
              "color": "teal"
            }
          }, 'v-avatar', attrs, false), on), [(_vm.getProfilePicture(colleague)) ? _c('v-img', {
            attrs: {
              "src": _vm.getProfilePicture(colleague)
            }
          }) : _c('span', [_vm._v(_vm._s(_vm.initials(colleague)))])], 1)]
        }
      }], null, true)
    }, [_vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(colleague.full_name))]), _vm._v(" "), _vm._l((colleague.memberships), function(mem) {
      return _c('div', [_vm._v("\n                    " + _vm._s(mem.role) + " @ " + _vm._s(mem.space_name) + "\n                  ")])
    })], 2)]), _vm._v(" "), _c('v-badge', {
      staticClass: "ctabs",
      attrs: {
        "bordered": "",
        "overlap": "",
        "small": "",
        "right": ""
      },
      scopedSlots: _vm._u([{
        key: "badge",
        fn: function() {
          return [_vm._v("+")]
        },
        proxy: true
      }], null, true)
    }, [_vm._v(" "), _c('v-btn', {
      attrs: {
        "icon": "",
        "small": "",
        "outline": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.newAppointment(colleague)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("event")])], 1)], 1)], 1) : _vm._e()]
  }), _vm._v(" "), _c('invite-btn', {
    attrs: {
      "text": "Invite",
      "icon": "add",
      "attrs": {
        flat: true
      }
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.loading) ? _c('v-progress-circular', {
    staticClass: "ma-2",
    attrs: {
      "indeterminate": "",
      "color": "amber",
      "width": "2"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.facets && _vm.facets.spaces) ? _vm._l((Object.keys(_vm.facets.spaces)), function(id) {
    return _c('v-chip', {
      key: id,
      staticClass: "v-chip--x-small mt-2",
      staticStyle: {
        "margin-top": "12px!important"
      },
      attrs: {
        "outline": "",
        "color": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.setSelectedSpace(id)
        }
      }
    }, [(_vm.selectedSpace === id) ? _c('v-icon', {
      staticClass: "ma-0",
      attrs: {
        "small": ""
      }
    }, [_vm._v("check")]) : _vm._e(), _vm._v("\n          " + _vm._s(_vm.facets.spaces[id].title) + "\n        ")], 1)
  }) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "to": "/calendar/team",
      "outline": "",
      "small": ""
    }
  }, [_vm._v("Team View")])], 2)] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a76db45","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pickers/CalendarTabs.vue
// module id = 1417
// module chunks = 9